/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import subPage from '../../subPage';
import { Grid } from 'semantic-ui-react';
import { PaletteChooser } from '../../../components/color';
import { ThemeSelector, LayoutPreview } from '../../../components/theme';
import Button from '../../../components/buttons';
import { Dialog } from '../../../components/dialogs';
import _ from '../../../translations';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import find from 'lodash/find';
import Form from '../../../components/automaticForm';
import palettes from './palettes';
import TutorialSegment from '../../../components/tutorialSegment';
import { setBreadcrumbSentry } from '../../../utils/sentry';
@subPage('/app-builder/layout')
@inject('tasksStore', 'templatesStore', 'siteMapStore', 'uiStore')
@observer
class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.title = 'Color and Layout';
        this.save = this.save.bind(this);
        this.state = {
            successModal: false,
            confirmModal: false,
            template: false,
            colorPalette: palettes[0],
            platform: 'mobile',
            userMadeChanges: false          
        };
    }

    async componentDidMount() {
        const { templatesStore, siteMapStore } = this.props;
   
        await templatesStore.listAll();
        await siteMapStore.getSitemap();
        if (siteMapStore.sitemap && siteMapStore.sitemap.colorPalette)
            this.setState({ colorPalette: siteMapStore.sitemap.colorPalette });
    }

   
    componentDidUpdate() {
        if (this.state.userMadeChanges) this.props.uiStore.lockNavigation();
    }

    onPaletteSelect = colorPalette => {
        this.setState({ colorPalette, userMadeChanges: true });
    };

    openSuccessModal = () => {
        this.setState({ successModal: true });
        setTimeout(() => {
            this.setState({ successModal: false });
        }, 3000);
    };
    openConfirmModal = () => this.setState({ confirmModal: true });

    closeSuccessModal = () => {
        this.setState({ successModal: null });
    };
    closeConfirmModal = () => {
        this.setState({ confirmModal: null });
    };
    setPlatform = platform => this.setState({ platform });

    async save() {
        this.state.userMadeChanges = false;
        this.props.uiStore.unlockNavigation();
        const { siteMapStore, templatesStore } = this.props;
        let { template, colorPalette } = this.state;

        if (!template) {
            if (siteMapStore.sitemap && siteMapStore.sitemap.Template) template = siteMapStore.sitemap.Template;
            else if (templatesStore.templates && templatesStore.templates[0])
                template = templatesStore.templates[0]._id;
        }
        if (!colorPalette) colorPalette = siteMapStore.sitemap.colorPalette;

        this.props.tasksStore.markAsDone(3);
        this.props.siteMapStore.setTemplate(template._id ? template._id : template);
        this.props.siteMapStore.setColorPalette(colorPalette);

        setBreadcrumbSentry({ 
            type: 'info',
            category: 'log',
            message : "Saving siteMap",
            data: { 
                sitemap: siteMapStore?.sitemap || false,
                section: '/app-builder/layout',
                action: 'appStore.replaceApp' 
            }
        });

        await this.props.siteMapStore.saveSiteMap();       
       

        this.openSuccessModal();
    }

    onThemeChange = template => {
        this.setState({ template: template._id, userMadeChanges: true });
    };

    getTemplate = _id => {
        const { templatesStore } = this.props;
        return find(toJS(templatesStore.templates), { _id });
    };

    componentWillUnmount() {
        this.props.uiStore.unlockNavigation();   
    }

    render() {
        let isCustom = false;
        const { successModal, confirmModal, platform } = this.state;
        let { template, colorPalette } = this.state;
        const { templatesStore, siteMapStore } = this.props;

        if (!template) {
            if (siteMapStore.sitemap && siteMapStore.sitemap.Template) template = siteMapStore.sitemap.Template;
            else if (templatesStore.templates && templatesStore.templates[0])
                template = templatesStore.templates[0]._id;
        }

        if (siteMapStore.sitemap && siteMapStore.sitemap.data) {
            const playlists = [];

            for (const key of Object.keys(siteMapStore.sitemap.data)) {
                const playlistsSection = toJS(siteMapStore.sitemap.data[key].playlists);

                if(playlistsSection) playlists.push(...playlistsSection);
            }

            isCustom = playlists.find(element => element.isCustom);
        }
       
        return (
            <React.Fragment>
                <style>{`
            span.active-platform {
              color: #19bac3;
              font-weight: 500;
            }
          `}</style>
                <TutorialSegment tutorialId={2} />
                <Grid style={{ margin: '1rem' }}>
                    <Grid.Column width={8} tablet={16} computer={8} largeScreen={8}>
                        <Form.Segment noMargin>
                            <ThemeSelector
                                templates={templatesStore.templates}
                                isCustom={isCustom}
                                title={_('See how it Looks & Works')}
                                onChange={this.onThemeChange}
                                value={template}
                            />
                            <div style={{ height: '4rem' }} />
                            <PaletteChooser
                                palettes={palettes}
                                onChange={this.onPaletteSelect}
                                title={_('Pick a Color Palette')}
                                description={_(
                                    'Your app will use the selected colors in all platforms. The multi-platform preview will be updated according to your selection'
                                )}
                                value={colorPalette}
                            />
                        </Form.Segment>
                    </Grid.Column>
                    <Grid.Column width={8} tablet={16} computer={8} largeScreen={8}>
                        <div
                            style={{
                                position: 'absolute',
                                maxHeight: 'calc(100vh - 70px)',
                                overflowY: 'auto',
                                width: '100%',
                                paddingRight: '1rem',
                                transition: 'margin 0.3s ease-in-out'
                            }}
                            className="nunchee-platform-previewer"
                        >
                            <Form.Segment noMargin style={{ maxHeight: 'calc(100vh - 235px)' }}>
                                <div style={{ overflow: 'hidden' }}>
                                    <h2 style={{ textAlign: 'left', float: 'left' }}>{_('Preview')}</h2>
                                    <div style={{ float: 'right' }}>
                                        <span
                                            className={platform === 'desktop' ? 'active-platform' : ''}
                                            style={{ padding: '0px 1rem', cursor: 'pointer' }}
                                            onClick={() => this.setPlatform('desktop')}
                                        >
                                            {_('Desktop')}
                                        </span>
                                        <span> | </span>
                                        <span
                                            className={platform === 'mobile' ? 'active-platform' : ''}
                                            style={{ padding: '0px 1rem', cursor: 'pointer' }}
                                            onClick={() => this.setPlatform('mobile')}
                                        >
                                            {_('Mobile')}
                                        </span>
                                        <span> | </span>
                                        <span
                                            className={platform === 'tablet' ? 'active-platform' : ''}
                                            style={{ padding: '0px 1rem', cursor: 'pointer' }}
                                            onClick={() => this.setPlatform('tablet')}
                                        >
                                            {_('Tablet')}
                                        </span>
                                    </div>
                                </div>
                                <If condition={template}>
                                    <LayoutPreview
                                        template={this.getTemplate(template)}
                                        palette={colorPalette}
                                        platform={platform}
                                    />
                                </If>
                            </Form.Segment>
                            <Form.Segment noMargin style={{ marginTop: '2rem' }}>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Button type="accept" onClick={this.save}>
                                        {_('Save')}
                                    </Button>
                                </div>
                            </Form.Segment>
                        </div>
                    </Grid.Column>
                </Grid>
                <Dialog
                    type="confirm"
                    title={_('Alert!')}
                    message={_('Are you sure you want to undo the changes?')}
                    open={confirmModal}
                    closeIcon
                    onClose={this.closeConfirmModal}
                    onAccept={this.closeConfirmModal}
                    onCancel={this.closeConfirmModal}
                />
                <Dialog
                    type="success"
                    title={_('Success')}
                    message={_('The changes were saved correctly.')}
                    open={successModal}
                    closeIcon
                    onClose={this.closeSuccessModal}
                />
            </React.Fragment>
        );
    }
}

export default Layout;
export { palettes };
